import { Text, View, Image, StyleSheet } from "@react-pdf/renderer";
import Logo from "../../assets/images/Bodybon-Logo.png";
import Profile from "../../assets/icons/profile.png";
import Birthday from "../../assets/icons/birthday.png";
import Calendar from "../../assets/icons/calendar.png";
import Height from "../../assets/icons/height.png";
import Weight from "../../assets/icons/weight.png";
import TestType from "../../assets/icons/test-type.png";
import {
  formateDateToJalali,
  genderConverter,
  typePersianConverter,
} from "../../utils/Functions";

const styles = StyleSheet.create({
  container: {
    height: "100%",
    padding: 50,
    flexDirection: "column",
    alignItems: "center",
    justifyContent: "center",
    backgroundColor: "#fff",
  },
  title: {
    color: "#fff",
    fontSize: 14,
    fontWeight: "bold",
  },
  testDataContainer: {
    width: "100%",
    height: "100%",
    flexDirection: "row-reverse",
    alignItems: "center",
    justifyContent: "space-around",
    flexWrap: "wrap",
    gap: 15,
    marginTop: 60,
  },
  testDataItem: {
    width: "45%",
    flexDirection: "row-reverse",
    alignItems: "center",
    justifyContent: "flex-start",
    padding: 15,
    borderRadius: 15,
    borderWidth: 1,
    borderColor: "#eee",
  },
  testDataInfo: {
    width: "100%",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "flex-end",
  },
  icon: {
    width: 110,
    height: 80,
    marginLeft: 30,
  },
  label: {
    fontFamily: "rokh",
    fontSize: 20,
    fontWeight: 900,
    marginTop: 10,
  },
  value: {
    fontSize: 22,
    fontWeight: "bold",
  },
});

const PdfTestIntro = ({ testInfo }: any) => {
  const testData = [
    { icon: Profile, title: ":آزمایش‌دهنده", data: testInfo?.name || "" },
    {
      icon: TestType,
      title: ":جنسیت",
      data: genderConverter(testInfo.gender),
    },
    {
      icon: Birthday,
      title: ":تاریخ تولد",
      data: testInfo?.birth_day
        ? formateDateToJalali(testInfo?.birth_day)
        : "-",
    },
    {
      icon: Calendar,
      title: ":تاریخ انجام آزمایش",
      data: testInfo?.test_date
        ? formateDateToJalali(testInfo?.test_date)
        : "-",
    },
    { icon: Height, title: ":قد", data: testInfo?.height || "-" },
    { icon: Weight, title: ":وزن", data: testInfo?.weight || "-" },
  ];

  return (
    <View style={styles.container}>
      <View style={styles.testDataContainer}>
        {testData.map((item, index) => (
          <View key={index} style={styles.testDataItem}>
            <Image style={styles.icon} src={item.icon} />
            <View style={styles.testDataInfo}>
              <Text style={styles.label}>{item.title}</Text>
              <Text style={styles.value}>{item.data}</Text>
            </View>
          </View>
        ))}
      </View>
    </View>
  );
};

export default PdfTestIntro;
